import Banner from 'app/components/partials/banner';
import ContentBlocks from 'app/components/content-blocks/index';
import PropTypes from 'prop-types';
import React from 'react';

function Page(props) {
    const {
        blocks,
        name: title,
        parent: parentSlug
    } = props.data;

    return (
        <div className="content-page">
            <Banner
                title={title}
                parentSlug={parentSlug}
            />
            <ContentBlocks data={blocks} />
        </div>
    );
}

Page.propTypes = {
    data: PropTypes.object.isRequired
};

export default Page;
